import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';

const VisionCriteria3 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { onBooleanCheckboxFilterChange, getFilterBooleanCheckboxValue },
  } = useRootStore();

  const filterName = 'Fit and Follow Up';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'follow-up',
      label: 'Discount charge for contact lens fit and follow-up',
      value: 'follow-up',
    },
    {
      id: 'all',
      label: 'Show me all options',
      value: 'all',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Choose Contact Lens Fit and Follow-up Benefit"
        subtitle="Contact lens fittings usually require additional services from a vision provider. You can choose plans that cover this service at a discounted fee ($40) or you can cover the entire fee at no cost to your employees."
      />
      <RadioGroup
        label=""
        // follow-up - is filterValue for which in filters object will be stored boolean value
        value={getFilterBooleanCheckboxValue(filterName, 'follow-up')}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBooleanCheckboxFilterChange(filterName, e.target.value);
        }}
      />
    </div>
  );
});

export default withCriteria(VisionCriteria3, 3);
